module.exports = __webpack_public_path__ + "img/tab-background-left-v2.53029265.svg";